// extracted by mini-css-extract-plugin
module.exports = {"icon":"NotificationIcon-module__icon___ybj-c"};